<template>
  <!-- Spec 2026-10-07-bo-form-draft-clear-design.md §3 F2: leftmost of the
       header button group, same size as "กลับ" / "บันทึก". -->
  <base-button
    size="md"
    type="neutral"
    data-testid="form-clear"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <i class="fa fa-eraser mr-1"></i>{{ $t("form_draft.clear") }}
  </base-button>
</template>
<script>
export default {
  name: "FormClearButton",
  props: {
    disabled: { type: Boolean, default: false }
  }
};
</script>
